export const usersApiPageSelector = (state, page) => {
  return state.api.users.pages[page];
};
